module.exports = ".container-main {\n  padding: 12px; }\n\nh3 {\n  margin-top: 3px;\n  margin-bottom: 3px; }\n"